import Vue from 'vue';

Vue.component('index-bank', require('./components/application/IndexBank').default);
Vue.component('index-transactiontype', require('./components/application/IndexTransactionTypes').default);
Vue.component('index-position', require('./components/application/IndexPosition').default);

// Modals
Vue.component('modal-bank', require('./components/application/BankAddModal').default);
Vue.component('modal-transactiontype', require('./components/application/TransaccionTypesAddModal').default);
Vue.component('modal-position', require('./components/application/PositionAddModal').default);

// Formularios de edicion
Vue.component('edit-bank', require('./components/application/EditBank').default);
Vue.component('bank-add-modal', require('./components/application/EditPosition').default);

// Compromisos de Cumplimiento
Vue.component('compliance-commitments-table', require('./components/compliance-commitments/Index').default);
Vue.component('compliance-commitments-modal', require('./components/compliance-commitments/Modal').default);

// Anexos
Vue.component('annexes-table', require('./components/annexes/Index').default);
Vue.component('annexes-modal', require('./components/annexes/Modal').default);

// Areas SAE
Vue.component('areas-table', require('./components/areas/Index').default);
Vue.component('areas-modal', require('./components/areas/Modal').default);

// Actividades
Vue.component('activities-table', require('./components/activities/Index').default);
Vue.component('activities-modal', require('./components/activities/Modal').default);
Vue.component('activities-text-modal', require('./components/activities/modal-text/Modal').default);

// Tipos de evaluadores
Vue.component('evaluator-types-table', require('./components/evaluator-types/Index').default);
Vue.component('evaluator-types-modal', require('./components/evaluator-types/Modal').default);

// Alcances
Vue.component('scope-master-table', require('./components/scopemaster/Index').default);
Vue.component('scope-master-modal', require('./components/scopemaster/Modal').default);

// Tipos de Acreditacion
Vue.component('acc-type-table', require('./components/acctype/Index').default);
Vue.component('acc-type-modal', require('./components/acctype/Modal').default);

// ACTIVIDADES CRITICAS
Vue.component('critical-activities-table', require('./components/criticalactivities/Index').default);
Vue.component('critical-activities-modal', require('./components/criticalactivities/Modal').default);


// Observaciones de solicitud
Vue.component('request-observations-table', require('./components/requestObservations/Index').default);
Vue.component('request-observations-modal', require('./components/requestObservations/Modal').default);

// Rules text
Vue.component('rules-evaluation-team-table', require('./components/rulesEvaluationTeam/Index').default);
Vue.component('rules-evaluation-team-modal', require('./components/rulesEvaluationTeam/Modal').default);

// Compromisos de OECs
Vue.component('compliance-commitments-oec-table', require('./components/compliance-commitments-oec/Index').default);
Vue.component('compliance-commitments-oec-modal', require('./components/compliance-commitments-oec/Modal').default);

// Estados
Vue.component('statuses-table', require('./components/statuses/Index').default);
Vue.component('statuses-modal', require('./components/statuses/Modal').default);

// Dias Festivos
Vue.component('holidays-table', require('./components/holidays/Index').default);
Vue.component('holidays-modal', require('./components/holidays/Modal').default);

// Carga de Datos Maestros
Vue.component('upload-master-data', require('./components/uploadata/Index').default);

// Normas de Acreditación
Vue.component('rules-table', require('./components/rules/Index').default);
Vue.component('rules-modal', require('./components/rules/Modal').default);

// Convenios
Vue.component('agreements-table', require('./components/agreements/Index').default);
Vue.component('agreements-modal', require('./components/agreements/Modal').default);

// Version
Vue.component('version-table', require('./components/version/Index').default);
Vue.component('version-modal', require('./components/version/Modal').default);

//Evaluator Scope
Vue.component('evaluator-scope-table', require('./components/evaluator-scope/Index').default);
Vue.component('evaluator-scope-modal', require('./components/evaluator-scope/Modal').default);

//Evaluator Rules
Vue.component('evaluator-rules-table', require('./components/evaluator-rules/Index').default);
Vue.component('evaluator-rules-modal', require('./components/evaluator-rules/Modal').default);

//Evaluator Activities
Vue.component('evaluator-activities', require('./components/evaluator-activities/Index').default);
Vue.component('evaluator-activites-modal', require('./components/evaluator-activities/Modal').default);


//Rates
Vue.component('rates-table', require('./components/rates/Index').default);
Vue.component('rates-modal', require('./components/rates/Modal').default);

// Tipos de resoluciones
Vue.component('resolution-types-table', require('./components/resolution-types/Index').default);
Vue.component('resolution-types-modal', require('./components/resolution-types/Modal').default);

// Plantillas de Certificado
Vue.component('certificate-templates-table', require('./components/certificate-templates/Index').default);
Vue.component('certificate-templates-modal', require('./components/certificate-templates/Modal').default);
Vue.component('generate-certificate-templates-modal', require('./components/certificate-templates/ModalCertificate').default);

// Motivo de Quejas
Vue.component('reason-complaint-table', require('./components/reasonComplaints/Index').default);
Vue.component('reason-complaint-modal', require('./components/reasonComplaints/Modal').default);

//Evaluator Scope Details
Vue.component('evaluator-scope-details', require('./components/evaluator-scope-details/Index').default);
Vue.component('evaluator-scope-details-modal', require('./components/evaluator-scope-details/Modal').default);

// Detalles de propuesta
Vue.component('proposal-details-table', require('./components/proposalDetails/Index').default);
Vue.component('proposal-details-modal', require('./components/proposalDetails/Modal').default);

//visualizar solicitudes
Vue.component('view-request-index', require('./components/view-requests/Index').default);
Vue.component('view-request-laboratory', require('./components/view-requests/Laboratory').default);
Vue.component('view-request-certification', require('./components/view-requests/Certification').default);
Vue.component('view-request-inspection', require('./components/view-requests/Inspection').default);

// Administar Firmas
Vue.component('manage-signatures-table', require('./components/manage-signatures/Index').default);
Vue.component('manage-signatures-modal', require('./components/manage-signatures/Modal').default);
